import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import type { MeResponse } from "@koc/shared";
import { apiAuth } from "../api.js";
import { Button, Card, Input, Label } from "../components/ui.js";

export function LoginPage({ onLoggedIn }: { onLoggedIn?: (m: MeResponse) => void } = {}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: () => apiAuth.login({ email, password }),
    onSuccess: (m) => {
      setError(null);
      if (onLoggedIn) onLoggedIn(m);
      else window.location.href = "/";
    },
    onError: (err: unknown) => {
      const status = err && typeof err === "object" && "status" in err ? (err as { status: number }).status : 0;
      setError(status === 429 ? "Too many attempts. Try again in a few minutes." : "Login failed.");
    },
  });

  return (
    <div className="flex h-screen items-center justify-center bg-stone-100">
      <Card className="w-96">
        <h1 className="text-xl font-semibold mb-4">KOC Platform · Sign in</h1>
        <form
          onSubmit={(e) => { e.preventDefault(); mutation.mutate(); }}
          className="space-y-3"
        >
          <div>
            <Label>Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" autoFocus required />
          </div>
          <div>
            <Label>Password</Label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required />
          </div>
          {error && <div className="text-sm text-red-600">{error}</div>}
          <Button type="submit" disabled={mutation.isPending} className="w-full justify-center">
            {mutation.isPending ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
